import { WHITE } from "../../constant/typograpy/colors";
import { ABSOLUTE, CENTER, FILL_PARENT, GRID } from "../../constant/typograpy/properties";
import SplitLoader from "./SplitLoader";

export default function WhiteFade({loader}) {

    return <div style={{ width: FILL_PARENT, backgroundColor: WHITE, position: ABSOLUTE, top: 0, height: FILL_PARENT, left: 0, opacity: "0.4", display:GRID, placeItems:CENTER }}>
       {loader &&  <SplitLoader center={true} />}
    </div>
}